module.exports = __webpack_public_path__ + "b8efc02fa542af80a7d8580b2345950c.svg";